import { Link, SpaceBetween, StatusIndicator, Popover } from '@amzn/awsui-components-react'
import { convertToLocalTime } from '../../../common/Util'
import { getNextUpdatedStartAtTimeString } from '../../reusable/AllocationUtils'
import { PHONE_TOOL_PREFIX, STATUS_INDICATOR_TYPES } from '../../../Constant'
import ValueWithLabelBox from '../../reusable/ValueWithLabelBox'

const TEAM_NAME_LIMIT = 48

const ManagerTeamHeaderGroup = (props) => {
    const { displayName, team, isMonthlyView, date } = props
    const name =
        displayName.length > TEAM_NAME_LIMIT
            ? `${displayName.slice(0, TEAM_NAME_LIMIT - 1)}...`
            : displayName
    if (!team) {
        return name
    }
    const hasUnscopedWeek = Object.values(team.scoped_weeks).includes(false)

    return (
        <Popover
            fixedWidth
            renderWithPortal
            dismissButton={false}
            position='top'
            size='medium'
            triggerType='custom'
            content={
                <SpaceBetween size='l'>
                    <ValueWithLabelBox label='Team Allocation'>
                        <Link
                            href={
                                isMonthlyView
                                    ? `/history/team/${team.team_id}`
                                    : `/allocation/${team.team_id}/${date}`
                            }
                            external
                            variant='secondary'
                        >
                            {displayName}
                        </Link>
                    </ValueWithLabelBox>
                    <ValueWithLabelBox label='Primary Contact'>
                        <Link
                            href={`${PHONE_TOOL_PREFIX}/${team.primary_alias}`}
                            external
                            variant='secondary'
                        >
                            {team.primary_alias}
                        </Link>
                    </ValueWithLabelBox>
                    <ValueWithLabelBox label='Allocation Submission Status'>
                        {Object.keys(team.scoped_weeks).map((week) => {
                            return team.scoped_weeks[week] ? (
                                <StatusIndicator
                                    key={`${team.team_id}-${week}.`}
                                >{`Submitted :${week}.`}</StatusIndicator>
                            ) : (
                                <StatusIndicator
                                    key={`${team.team_id}-${week}.`}
                                    type={STATUS_INDICATOR_TYPES.WARNING}
                                >{`Not submitted: ${week}.`}</StatusIndicator>
                            )
                        })}
                    </ValueWithLabelBox>
                    <ValueWithLabelBox label='HR Data Last Updated At'>
                        {convertToLocalTime(team.hr_headcount_last_updated_at)}
                    </ValueWithLabelBox>
                    <ValueWithLabelBox label='HR Data Next Update Starts At'>
                        {getNextUpdatedStartAtTimeString(team.hr_headcount_last_updated_at)}
                    </ValueWithLabelBox>
                </SpaceBetween>
            }
        >
            {
                <StatusIndicator
                    type={
                        hasUnscopedWeek
                            ? STATUS_INDICATOR_TYPES.WARNING
                            : STATUS_INDICATOR_TYPES.INFO
                    }
                    colorOverride={hasUnscopedWeek ? undefined : 'grey'}
                >
                    {name}
                </StatusIndicator>
            }
        </Popover>
    )
}

export default ManagerTeamHeaderGroup
